import { Alert, Button, Stack, Typography } from "@mui/material";
import type { LeagueSessionParticipationResponse } from "@bw/shared/types/generated";

export function SessionParticipationActions({
  state,
  number,
  pending,
  error,
  onJoin,
  onCancel,
}: {
  state?: LeagueSessionParticipationResponse;
  number: number;
  pending: boolean;
  error?: { action: "join" | "cancel"; message: string };
  onJoin: () => void;
  onCancel: () => void;
}) {
  if (!state)
    return (
      <Typography variant="body2" color="text.secondary">
        Session status unavailable.
      </Typography>
    );
  const showError =
    error &&
    (error.action === "join"
      ? state.status === "not_registered"
      : state.status === "registered");
  return (
    <Stack spacing={1}>
      <Typography variant="body2">
        {
          {
            not_registered: "Not registered",
            registered: "Registered",
            cancelled: "Cancelled",
          }[state.status]
        }
      </Typography>
      <Stack direction="row" spacing={1}>
        {state.can_join ? (
          <Button
            size="small"
            variant="outlined"
            aria-label={`Join session ${number}`}
            disabled={pending}
            aria-busy={pending}
            onClick={onJoin}
          >
            Join session
          </Button>
        ) : null}
        {state.can_cancel && state.session_reg_id ? (
          <Button
            size="small"
            aria-label={`Cancel session ${number}`}
            disabled={pending}
            aria-busy={pending}
            onClick={onCancel}
          >
            Cancel session
          </Button>
        ) : null}
      </Stack>
      {showError ? <Alert severity="error">{error.message}</Alert> : null}
    </Stack>
  );
}
